import React from 'react';
import { connect } from 'react-redux';
import "./custom.css";

const mapStateToProps = state => ({
    ...state.common
});

export class Footer extends React.Component {
    redirect = (url) => {
        this.props.history.push(url);
    }

    render() {
        return (
            <div>
                <div className="pull-right text-gray">
                    <label>Powered by NatWest Markets</label> <span class="logo-natwest-powered"></span>
                </div>
                <div className="footer pull-left">
                    <div className="container  footer-text">

                        <div className="row">
                            <div className="col-md-12 text-center">
                                The information published on this page is provided for educational and informational purposes only. Any rates calculated should not be used as a benchmark nor as a reference or input in financial instruments.
                                Please see&nbsp;
                        <a onClick={() => { this.redirect('/Disclaimer') }} className="font-weight-bold text-purple" title='Full Legal Disclaimer' target="_blank">
                                    full legal disclaimer here.
                        </a>
                        &nbsp;We are seeking feedback from market participants on the information presented here, and how it can be improved further to provide support in the transition from LIBOR towards Risk Free Rates. Please complete
                             <a href='https://natwestmarkets.fra1.qualtrics.com/jfe/form/SV_6zCR9cZvdgeYPWZ'
                                    title='https://natwestmarkets.fra1.qualtrics.com/jfe/form/SV_6zCR9cZvdgeYPWZ'
                                    target='_blank' rel="noopener noreferrer"> our survey here</a> to provide your feedback or contact us at <a href="mailto:rfr@natwestmarkets.com" target="_top">rfr@natwestmarkets.com</a>.

                            <br />
                            </div>
                        </div>
                    </div>
                    <div className="footer-back">
                        <p className="copyright"><a className="footerMenu" onClick={() => { this.redirect('/CookiePolicy') }}>Cookies policy</a> &nbsp; &nbsp;Copyright © NatWest Markets Plc. All rights reserved.</p>
                    </div>
                </div>
            </div>
        );
    };
}
export default connect(mapStateToProps)(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer.js